import { render, staticRenderFns } from "./performanceIndicator.vue?vue&type=template&id=634f15dd&scoped=true"
import script from "./performanceIndicator.vue?vue&type=script&lang=js"
export * from "./performanceIndicator.vue?vue&type=script&lang=js"
import style0 from "./performanceIndicator.vue?vue&type=style&index=0&id=634f15dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634f15dd",
  null
  
)

export default component.exports